import styled from 'styled-components'
import {FavouriteIcon, MTText, RegularButton} from '../../atoms'
import React from "react";
import { tokens } from '../../../assets/tokens'

export const Container = styled.div``

// Nombre con la escala del resto de fichas: 20/600 (antes 40 px en negrita)
export const Title = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0 24px;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${tokens.color.text.primary};
`

export const InfoList = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`
export const InfoItem = styled.div`
  display: flex;
`
export const InfoItemUnderlined = styled.div`
  display: flex;
  justify-content: space-between;
`
export const Label = styled(props => <MTText {...props} />)``
export const Text = styled(props => <MTText {...props} />)`
  text-align: left;
`
export const CommentsTable = styled.div`
  && {
    padding: 30px 0;
  }
  & .MuiTableSortLabel-root,
  th {
    color: ${({theme}) => theme.primary};
    &:hover {
      color: ${({theme}) => theme.primary};
    }
    &:focus {
      color: ${({theme}) => theme.primary};
    }
    &.MuiTableSortLabel-active {
      color: ${({theme}) => theme.primary};
    }
    & .MuiTableSortLabel-icon {
      color: ${({theme}) => theme.primary} !important;
    }
  }
`

export const ProcessTitle = styled.span``

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 20px;
`

export const ActionButton = styled(props => <RegularButton {...props}/>)`
  margin: 10px;
`
export const UserName = styled.p`
  font-size: 36px;
  font-weight: bold;
`

export const ProcessIsFavourite = styled(props => <FavouriteIcon {...props}/>)`
  font-size: 20px !important;
`

// Motivos de salida con la escala de los demás bloques: pregunta 14/500 y respuesta 14/400 (antes 17 px)
export const ExitReason = styled.div`
  padding: 12px 10px;
  border-bottom: solid 1px rgba(148,163,178,0.25);

  .reason_title {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${tokens.color.text.primary};
  }
  .reason_content {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${tokens.color.text.secondary};
  }
`
